export const TEST_PAYLOAD = {
  guilds: [
    {
      guild: {
        id: 1047044,
        name: 'Echo',
        faction: 'horde',
        realm: {
          id: 719,
          connectedRealmId: 300,
          name: 'Tarren Mill',
          altName: null,
          slug: 'tarren-mill',
          altSlug: 'tarren-mill',
          locale: 'en_GB',
          isConnected: true
        },
        region: {
          name: 'Europe',
          slug: 'eu',
          short_name: 'EU'
        },
        path: '/guilds/eu/tarren-mill/Echo',
        logo: 'https://cdn.raiderio.net/images/rwf/sepulcher-of-the-first-ones/echo/guildlogo.png',
        color: '#cd1d2d'
      },
      raid: {
        difficulty: 'mythic',
        name: 'Sepulcher of the First Ones',
        short_name: 'SFO',
        slug: 'sepulcher-of-the-first-ones',
        expansion_id: 8
      },
      bosses: [
        {
          boss: {
            encounterId: 180773,
            name: 'Vigilant Guardian',
            slug: 'vigilant-guardian',
            ordinal: 0,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/vigilant-guardian.jpg'
          },
          bestPercent: 0,
          pullCount: 1,
          pullStartedAt: '2022-03-10T14:50:36.130Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183937,
            name: 'Skolex',
            slug: 'skolex',
            ordinal: 1,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/skolex.jpg'
          },
          bestPercent: 0,
          pullCount: 2,
          pullStartedAt: '2022-03-10T15:24:28.631Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183501,
            name: "Artificer Xy'mox",
            slug: 'artificer-xymox',
            ordinal: 2,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/artificer-xymox.jpg'
          },
          bestPercent: 0,
          pullCount: 3,
          pullStartedAt: '2022-03-10T17:04:30.503Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181224,
            name: 'Dausegne',
            slug: 'dausegne',
            ordinal: 3,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/dausegne.jpg'
          },
          bestPercent: 0,
          pullCount: 5,
          pullStartedAt: '2022-03-10T16:16:57.491Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181549,
            name: 'Prototype Pantheon',
            slug: 'prototype-pantheon',
            ordinal: 4,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/prototype-pantheon.jpg'
          },
          bestPercent: 0,
          pullCount: 23,
          pullStartedAt: '2022-03-10T21:25:48.266Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182169,
            name: 'Lihuvim',
            slug: 'lihuvim',
            ordinal: 5,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lihuvim.jpg'
          },
          bestPercent: 0,
          pullCount: 21,
          pullStartedAt: '2022-03-11T14:16:08.968Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 184915,
            name: 'Halondrus',
            slug: 'halondrus',
            ordinal: 6,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/halondrus.jpg'
          },
          bestPercent: 0,
          pullCount: 361,
          pullStartedAt: '2022-03-15T12:42:11.160Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181954,
            name: 'Anduin Wrynn',
            slug: 'anduin-wrynn',
            ordinal: 7,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/anduin-wrynn.jpg'
          },
          bestPercent: 0,
          pullCount: 153,
          pullStartedAt: '2022-03-18T21:52:37.848Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 26533,
            name: 'Lords of Dread',
            slug: 'lords-of-dread',
            ordinal: 8,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lords-of-dread.jpg'
          },
          bestPercent: 0,
          pullCount: 62,
          pullStartedAt: '2022-03-19T19:41:34.053Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182777,
            name: 'Rygelon',
            slug: 'rygelon',
            ordinal: 9,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/rygelon.jpg'
          },
          bestPercent: 0,
          pullCount: 180,
          pullStartedAt: '2022-03-21T14:56:09.623Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 185421,
            name: 'The Jailer',
            slug: 'the-jailer',
            ordinal: 10,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/the-jailer.jpg'
          },
          bestPercent: 0,
          pullCount: 274,
          pullStartedAt: '2022-03-26T21:49:50.217Z',
          isDefeated: 1
        }
      ]
    },
    {
      guild: {
        id: 1712677,
        name: 'Liquid',
        faction: 'horde',
        realm: {
          id: 369,
          connectedRealmId: 207,
          name: 'Illidan',
          altName: null,
          slug: 'illidan',
          altSlug: 'illidan',
          locale: 'en_US',
          isConnected: false
        },
        region: {
          name: 'United States & Oceania',
          slug: 'us',
          short_name: 'US'
        },
        path: '/guilds/us/illidan/Liquid',
        logo: 'https://cdn.raiderio.net/images/rwf/sepulcher-of-the-first-ones/liquid/guildlogo.png',
        color: '#ffffff'
      },
      raid: {
        difficulty: 'mythic',
        name: 'Sepulcher of the First Ones',
        short_name: 'SFO',
        slug: 'sepulcher-of-the-first-ones',
        expansion_id: 8
      },
      bosses: [
        {
          boss: {
            encounterId: 180773,
            name: 'Vigilant Guardian',
            slug: 'vigilant-guardian',
            ordinal: 0,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/vigilant-guardian.jpg'
          },
          bestPercent: 0,
          pullCount: 3,
          pullStartedAt: '2022-03-09T22:32:35.353Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183937,
            name: 'Skolex',
            slug: 'skolex',
            ordinal: 1,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/skolex.jpg'
          },
          bestPercent: 0,
          pullCount: 2,
          pullStartedAt: '2022-03-09T23:03:37.487Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183501,
            name: "Artificer Xy'mox",
            slug: 'artificer-xymox',
            ordinal: 2,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/artificer-xymox.jpg'
          },
          bestPercent: 0,
          pullCount: 16,
          pullStartedAt: '2022-03-10T01:37:45.300Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181224,
            name: 'Dausegne',
            slug: 'dausegne',
            ordinal: 3,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/dausegne.jpg'
          },
          bestPercent: 0,
          pullCount: 4,
          pullStartedAt: '2022-03-10T02:30:28.717Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181549,
            name: 'Prototype Pantheon',
            slug: 'prototype-pantheon',
            ordinal: 4,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/prototype-pantheon.jpg'
          },
          bestPercent: 0,
          pullCount: 34,
          pullStartedAt: '2022-03-10T16:26:27.199Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182169,
            name: 'Lihuvim',
            slug: 'lihuvim',
            ordinal: 5,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lihuvim.jpg'
          },
          bestPercent: 0,
          pullCount: 40,
          pullStartedAt: '2022-03-11T03:33:43.794Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 184915,
            name: 'Halondrus',
            slug: 'halondrus',
            ordinal: 6,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/halondrus.jpg'
          },
          bestPercent: 0,
          pullCount: 340,
          pullStartedAt: '2022-03-14T17:07:18.012Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181954,
            name: 'Anduin Wrynn',
            slug: 'anduin-wrynn',
            ordinal: 7,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/anduin-wrynn.jpg'
          },
          bestPercent: 0,
          pullCount: 216,
          pullStartedAt: '2022-03-18T17:18:34.023Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 26533,
            name: 'Lords of Dread',
            slug: 'lords-of-dread',
            ordinal: 8,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lords-of-dread.jpg'
          },
          bestPercent: 0,
          pullCount: 81,
          pullStartedAt: '2022-03-19T23:09:53.861Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182777,
            name: 'Rygelon',
            slug: 'rygelon',
            ordinal: 9,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/rygelon.jpg'
          },
          bestPercent: 0,
          pullCount: 243,
          pullStartedAt: '2022-03-21T19:46:12.811Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 185421,
            name: 'The Jailer',
            slug: 'the-jailer',
            ordinal: 10,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/the-jailer.jpg'
          },
          bestPercent: 0,
          pullCount: 370,
          pullStartedAt: '2022-03-30T20:56:00.899Z',
          isDefeated: 1
        }
      ]
    }
  ],
  numEncounters: 11
};
